import React, { useEffect, useRef, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import PaginationComponent from '../PaginationComponent';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import SbActionDropdownButton from '../Buttons/SbActionDropdownButton';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import noDataFound from '../../assets/images/no-data-found.svg';
import noModuleAccess from '../../assets/images/no-module-access.svg';
import moment from 'moment';
import { Link, useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import SbCancelBtn, { SBSaveUpdateBtn } from '../Buttons/Buttons';
import * as HeaderAuthentication from '../HeaderAuthentication';
import { useDispatch } from 'react-redux';
import { postResendVerifyEmail, postSwitchToClientDatas } from '../../redux/action';
import { FaCheck, FaTimes } from "react-icons/fa";
import oktaLogo from '../../assets/images/Login/okta-logo.svg'
import microsoftLogo from '../../assets/images/Login/microsoft-icon.svg'
import { baseURL } from '../BaseUrl';
import Swal from 'sweetalert2';

const columns = [
    { id: 'CompanyID', label: 'ID', align: 'left', minWidth: '80px' },
    { id: 'CompanyCode', label: 'COMPANY CODE', align: 'left', minWidth: '180px' },
    { id: 'CompanyName', label: 'COMPANY', align: 'left', minWidth: '180px' },
    { id: 'ContactPerson', label: 'NAME', align: 'left', minWidth: '150px' },
    // { id: 'relationshipType', label: 'RELATIONSHIP TYPE ', align: 'left', minWidth: '200px' },
    { id: 'NoOfLicenses', label: 'NO.OF.LICENSE', align: 'left', minWidth: '100px' },
    { id: 'EmailID', label: 'EMAIL', align: 'left', minWidth: '250px' },
    { id: 'Address', label: 'ADDRESS', align: 'left', minWidth: '250px' },
    { id: 'StartDate', label: 'START DATE', align: 'left', minWidth: '180px' },
    { id: 'EndDate', label: 'END DATE', align: 'left', minWidth: '180px' },
    // { id: 'assignedModules', label: 'ASSIGNED MODULES', align: 'left', minWidth: '200px' },
    { id: 'Status', label: 'STATUS', align: 'left', minWidth: '130px' },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const SortableHead = SortableContainer(({ children }) => {
    return (
        <TableHead>
            <TableRow>{children}</TableRow>
        </TableHead>
    );
});

const SortableCell = SortableElement(({ value }) => {
    return <TableCell>{value}</TableCell>;
});

// Okta Configurations
const oktaDomain = "https://dev-11921071.okta.com";
const clientId = "0oana2n5klKQnEcMg5d7";
// const redirectUri = "http://localhost:3001/";
const redirectUri =
    window.location.hostname === "localhost"
        ? "http://localhost:3000/customermanagement"
        : "https://excomatix.betaphase.in/customermanagement";
const state = "1234";

// Generate Code Verifier
function generateCodeVerifier() {
    const randomValues = new Uint8Array(64);
    window.crypto.getRandomValues(randomValues);
    return btoa(String.fromCharCode.apply(null, randomValues))
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '');
}

// Generate Code Challenge
async function generateCodeChallenge(codeVerifier) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier))
        .then(buffer => {
            return btoa(String.fromCharCode(...new Uint8Array(buffer)))
                .replace(/=/g, '')
                .replace(/\+/g, '-')
                .replace(/\//g, '_');
        });
}

const CustomerManagementTable = ({ companyData = [], singleCustomerData = [], userRefId, selectedColumns, loading, handleOpenModal, handleViewDetails, handleOpenValueFilterModal, page, setPage, rowsPerPage, setRowsPerPage, moduleData, totalDataCount, showSwitchModal, setShowSwitchModal, handleSwitchClientCancel, handleSwitchClientConfirm, signInDetails, setCompanyId, customerManagementData, companyId, signInType, PreviousCompanyID, PreviousSuperAdminID, navigate, showImageDiv, setShowImageDiv, moduleId }) => {

    // Okta Login Function
    async function handleOctaAuth() {
        const codeVerifier = generateCodeVerifier();
        sessionStorage.setItem('code_verifier', codeVerifier);
        sessionStorage.setItem('switch_companyId', companyId);
        const codeChallenge = await generateCodeChallenge(codeVerifier);
        const authUrl = `${oktaDomain}/oauth2/default/v1/authorize?client_id=${clientId}&response_type=code&scope=openid profile email offline_access&redirect_uri=${redirectUri}&state=${state}&code_challenge=${codeChallenge}&code_challenge_method=S256`;

        // console.log("Redirecting to:", authUrl);
        window.location.href = authUrl;
    }

    function handleloginWithMicrosoft() {
        sessionStorage.setItem('switch_companyId', companyId);
        // const clientId = "a821f06c-fc66-4f64-8dbe-c1542ae82289";
        const clientId = "ad982bcc-bdf5-473d-ad72-64a504a907f5";
        // const clientId = "2tY8Q~9HCMAzRcSYH0bU5BOmJfUg6TuA1P7bqbCV";
        const redirectUri = window.location.hostname === "localhost"
            ? "http://localhost:3000/customermanagement"
            : "https://excomatix.betaphase.in/customermanagement"; // Must match registered URI in Azure
        const scope = "openid profile email offline_access";
        //const scope = "api://a821f06c-fc66-4f64-8dbe-c1542ae82289/openid";
        // const response_type = "id_token token";
        const responseType = "code"; // Change 'token' to 'code'

        const authUrl = "https://login.microsoftonline.com/f530b5f9-ab7e-452a-86fb-3b5a5a0250f0/oauth2/v2.0/authorize" +
            "?client_id=" + encodeURIComponent(clientId) +
            "&response_type=" + encodeURIComponent(responseType) + // Use 'code' instead of 'token'
            "&redirect_uri=" + encodeURIComponent(redirectUri) +
            "&scope=" + encodeURIComponent(scope) +
            //"&response_type=" + encodeURIComponent(scope) +
            "&response_mode=query" + // 'query' ensures the code is in the URL
            "&prompt=login" +
            "&state=microsoft"; // ✅ This differentiates Microsoft login

        window.location.href = authUrl;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    // const companyData = props.companyData || [];

    const dispatch = useDispatch();
    // const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    // const signInType = signInDetails ? signInDetails[0].SignInType : null;
    const DateFormat = signInDetails[0]?.DateFormat;

    // Get selected columns (based on `selectedColumns` prop)
    const filteredColumns = columns.filter((column) =>
        selectedColumns.includes(column.label)
    );

    const getStoredColumnsOrder = () => {
        const savedOrder = localStorage.getItem('companyColumnsOrder');
        return savedOrder ? JSON.parse(savedOrder) : columns.map((col) => col.id);
    };

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [clickedCell, setClickedCell] = useState({ rowId: null, columnId: null }); // Track clicked cell
    const [columnsOrder, setColumnsOrder] = useState(getStoredColumnsOrder());
    const [customerStatus, setCustomerStatus] = useState("");
    const [companyName, setCompanyName] = useState("");

    // Pagination state
    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
    const [paginatedData, setPaginatedData] = useState([]);
    // const [showSwitchModal, setShowSwitchModal] = useState(false); // For new modal
    const location = useLocation();

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const onReorderEnd = ({ oldIndex, newIndex }) => {
        const newOrder = Array.from(columnsOrder);
        const [moved] = newOrder.splice(oldIndex, 1);
        newOrder.splice(newIndex, 0, moved);
        setColumnsOrder(newOrder);
        localStorage.setItem('companyColumnsOrder', JSON.stringify(newOrder)); // Store new order
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = companyData.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [companyData, order, orderBy]);

    // Pagination logic
    // useEffect(() => {
    //     const start = page * rowsPerPage; // Updated page logic to 0-based
    //     const end = start + rowsPerPage;
    //     setPaginatedData(sortedData.slice(start, end));
    // }, [sortedData, page, rowsPerPage]);

    const filteredData = userRefId ? (singleCustomerData ? singleCustomerData : []) : companyData;

    useEffect(() => {
        if (!companyData || companyData.length === 0) {
            console.warn("⚠️ No Company Data Found!");
            setPaginatedData([]);
            return;
        }

        // Sort data based on order & orderBy
        const sorted = [...companyData].sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            return a[orderBy] < b[orderBy] ? -1 * orderModifier : 1 * orderModifier;
        });

        // Calculate pagination
        const maxPage = Math.ceil(sorted.length / rowsPerPage);
        const newPage = Math.min(page, maxPage - 1); // Prevents out-of-range pages

        const start = newPage * rowsPerPage;
        const end = start + rowsPerPage;
        const paginated = sorted.slice(start, end);

        setPaginatedData(paginated);
    }, [companyData, order, orderBy, page, rowsPerPage]);


    const handlePageChange = (newPage) => {
        setPage(newPage - 1); // Handle 1-based to 0-based page index for slicing
    };
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };

    // const handleSwitchClientConfirm = (e) => {
    //     e.preventDefault();

    //     let SigninID = null;

    //     if (signInType === "SuperAdmin") {
    //         SigninID = signInDetails[0].SuperAdminID; // Use SuperAdminID for SuperAdmin type
    //     } else if (signInType === "ClientAdmin") {
    //         SigninID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin type
    //     } else if (signInType === "User") {
    //         SigninID = signInDetails[0].UserID; // Use UserID for User type
    //     }

    //     const data = {
    //         "SigninID": SigninID,
    //         "CompanyID": 40
    //     };

    //     let requestOption = {
    //         method: "POST",
    //         mode: "cors",
    //         headers: HeaderAuthentication.postExcomatixAuth,
    //         body: JSON.stringify(data),
    //     };

    //     dispatch(postSwitchToClientDatas(requestOption, handleSwitchClientCancel));
    // };

    // const handleSwitchClientCancel = () => {
    //     setShowSwitchModal(false);
    // };

    const handleResendEmailVerification = (EncCompanyCode, EncSignInType) => {
        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                Company_Code: EncCompanyCode, // Use companyCode passed from the button
                SignInType: EncSignInType
            }),
        };
        dispatch(postResendVerifyEmail(requestOption, customerManagementData));
    };

    const handleOpenAthenticator = () => {
        setShowImageDiv(true);
    };

    const [message, setMessage] = useState("");

    // useEffect(() => {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     const authorizationCode = urlParams.get("code");
    //     const stateParam = urlParams.get("state"); // Identify Microsoft vs Okta
    //     const codeVerifier = sessionStorage.getItem("code_verifier"); // Only exists for Okta
    //     const storedCompanyId = sessionStorage.getItem("switch_companyId"); // 👈 Retrieve here

    //     if (authorizationCode) {
    //         if (codeVerifier) {
    //             // ✅ Okta Authentication (only triggered if `code_verifier` exists)
    //             fetch(`${baseURL}/accountservices/api/account/OktaAuthentication`, {
    //                 method: "POST",
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5"
    //                 },
    //                 body: JSON.stringify({ AuthorizationCode: authorizationCode, CodeVerifier: codeVerifier }),
    //             })
    //                 .then((res) => res.json())
    //                 .then(async (resp) => {
    //                     if (resp.Success) {
    //                         sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails));
    //                         sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules));
    //                         sessionStorage.setItem("Success", "1");

    //                         if (signInDetails.length > 0) {
    //                             sessionStorage.setItem("PreviousSuperAdminID", signInDetails[0]?.SuperAdminID ?? "null");
    //                             sessionStorage.setItem("PreviousSuperAdminName", signInDetails[0]?.UserName ?? "null");
    //                             sessionStorage.setItem("PreviousSuperAdminEmailId", signInDetails[0]?.EmailID ?? "null");
    //                             sessionStorage.setItem("PreviousSuperAdminImage", signInDetails[0]?.Image ?? "null");
    //                             sessionStorage.setItem("PreviousSuperAdminSignInType", signInDetails[0]?.SignInType ?? "null");
    //                         }

    //                         let SigninID = null;

    //                         if (signInType === "SuperAdmin") {
    //                             SigninID = signInDetails[0].SuperAdminID; // Use SuperAdminID for SuperAdmin type
    //                         } else if (signInType === "ClientAdmin") {
    //                             SigninID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin type
    //                         } else if (signInType === "User") {
    //                             SigninID = signInDetails[0].UserID; // Use UserID for User type
    //                         }

    //                         const data = {
    //                             "SigninID": PreviousCompanyID ? PreviousSuperAdminID : SigninID,
    //                             "CompanyID": storedCompanyId
    //                         };

    //                         let requestOption = {
    //                             method: "POST",
    //                             mode: "cors",
    //                             headers: HeaderAuthentication.postExcomatixAuth,
    //                             body: JSON.stringify(data),
    //                         };
    //                         dispatch(postSwitchToClientDatas(requestOption, handleSwitchClientCancel, navigate));
    //                     } else {
    //                         setMessage("Okta Authentication Failed: " + resp.Msg);
    //                     }
    //                 })
    //                 .catch((error) => {
    //                     setMessage("Okta Authentication Failed: " + error.message);
    //                 });
    //         } else {
    //             setMessage("Unknown Authentication Attempt.");
    //         }
    //     }
    // }, []);

    const effectRan = useRef(false);
    useEffect(() => {
        if (effectRan.current) return; // Skip if effect already ran (in Strict Mode second call)
        effectRan.current = true;
        const urlParams = new URLSearchParams(window.location.search);
        const authorizationCode = urlParams.get("code");
        const stateParam = urlParams.get("state"); // Identify Microsoft vs Okta
        const codeVerifier = sessionStorage.getItem("code_verifier"); // Only exists for Okta
        const storedCompanyId = sessionStorage.getItem("switch_companyId"); // 👈 Retrieve here

        if (authorizationCode) {
            const cleanupUrl = () => {
                // Remove ?code=...&state=... from the URL without reloading
                window.history.replaceState({}, document.title, window.location.pathname);
            };
            if (stateParam === "microsoft") {
                // ✅ Microsoft Authentication
                fetch(`${baseURL}/accountservices/api/account/MicrosoftAuthentication`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5"
                    },
                    body: JSON.stringify({ AuthorizationCode: authorizationCode, EmailID: signInDetails[0]?.EmailID }),
                })
                    .then((res) => res.json())
                    .then(async (resp) => {
                        if (resp.Success) {
                            // sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails));
                            // sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules));
                            // sessionStorage.setItem("Success", "1");

                            if (signInDetails.length > 0) {
                                sessionStorage.setItem("PreviousSuperAdminID", signInDetails[0]?.SuperAdminID ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminName", signInDetails[0]?.UserName ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminEmailId", signInDetails[0]?.EmailID ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminImage", signInDetails[0]?.Image ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminSignInType", signInDetails[0]?.SignInType ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminCompanyName", signInDetails[0]?.CompanyName ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminMobile", signInDetails[0]?.Mobile ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminZipCode", signInDetails[0]?.ZipCode ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminAddress", signInDetails[0]?.Address ?? "null");
                            }

                            let SigninID = null;

                            if (signInType === "SuperAdmin") {
                                SigninID = signInDetails[0].SuperAdminID; // Use SuperAdminID for SuperAdmin type
                            } else if (signInType === "ClientAdmin") {
                                SigninID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin type
                            } else if (signInType === "User") {
                                SigninID = signInDetails[0].UserID; // Use UserID for User type
                            }

                            const data = {
                                "SigninID": PreviousCompanyID ? PreviousSuperAdminID : SigninID,
                                "CompanyID": storedCompanyId
                            };

                            let requestOption = {
                                method: "POST",
                                mode: "cors",
                                headers: HeaderAuthentication.postExcomatixAuth,
                                body: JSON.stringify(data),
                            };
                            dispatch(postSwitchToClientDatas(requestOption, handleSwitchClientCancel, navigate));
                        } else {
                            setMessage("Microsoft Authentication Failed: " + resp.Msg);
                            Swal.fire({
                                title: 'Failed',
                                text: resp.Msg,
                                icon: 'error',
                            });
                            cleanupUrl();
                            navigate('/customermanagement', { state: { moduleId: 2 } })
                        }
                    })
                    .catch((error) => {
                        setMessage("Microsoft Authentication Failed: " + error.message);
                    });
            } else if (codeVerifier) {
                // ✅ Okta Authentication (only triggered if `code_verifier` exists)
                fetch(`${baseURL}/accountservices/api/account/OktaAuthentication`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5"
                    },
                    body: JSON.stringify({ AuthorizationCode: authorizationCode, CodeVerifier: codeVerifier, EmailID: signInDetails[0]?.EmailID }),
                })
                    .then((res) => res.json())
                    .then(async (resp) => {
                        if (resp.Success) {
                            sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails));
                            sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules));
                            sessionStorage.setItem("Success", "1");

                            if (signInDetails.length > 0) {
                                sessionStorage.setItem("PreviousSuperAdminID", signInDetails[0]?.SuperAdminID ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminName", signInDetails[0]?.UserName ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminEmailId", signInDetails[0]?.EmailID ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminImage", signInDetails[0]?.Image ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminSignInType", signInDetails[0]?.SignInType ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminCompanyName", signInDetails[0]?.CompanyName ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminMobile", signInDetails[0]?.Mobile ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminZipCode", signInDetails[0]?.ZipCode ?? "null");
                                sessionStorage.setItem("PreviousSuperAdminAddress", signInDetails[0]?.Address ?? "null");
                            }

                            let SigninID = null;

                            if (signInType === "SuperAdmin") {
                                SigninID = signInDetails[0].SuperAdminID; // Use SuperAdminID for SuperAdmin type
                            } else if (signInType === "ClientAdmin") {
                                SigninID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin type
                            } else if (signInType === "User") {
                                SigninID = signInDetails[0].UserID; // Use UserID for User type
                            }

                            const data = {
                                "SigninID": PreviousCompanyID ? PreviousSuperAdminID : SigninID,
                                "CompanyID": storedCompanyId
                            };

                            let requestOption = {
                                method: "POST",
                                mode: "cors",
                                headers: HeaderAuthentication.postExcomatixAuth,
                                body: JSON.stringify(data),
                            };
                            dispatch(postSwitchToClientDatas(requestOption, handleSwitchClientCancel, navigate));
                        } else {
                            setMessage("Okta Authentication Failed: " + resp.Msg);
                            Swal.fire({
                                title: 'Failed',
                                text: resp.Msg,
                                icon: 'error',
                            });
                            cleanupUrl();
                            navigate('/customermanagement', { state: { moduleId: 2 } })
                        }
                    })
                    .catch((error) => {
                        setMessage("Okta Authentication Failed: " + error.message);
                    });
            } else {
                setMessage("Unknown Authentication Attempt.");
            }
        }
    }, []);

    return (
        <>
            {moduleData?.CanView === true ? (
                <>
                    <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                        <Table>
                            {/* <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }} className='table-header-div'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {column.label}
                                        {column.sortable !== false && (
                                            <IconButton
                                                size="small"
                                                onClick={(event) => handleRequestSort(event, column.id)}
                                            >
                                                <img src={SortIcon} alt="Sort" />
                                            </IconButton>
                                        )}
                                    </div>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead> */}

                            <SortableHead axis="x" onSortEnd={onReorderEnd}>
                                {columnsOrder.map((columnId, index) => {
                                    const column = columns.find(col => col.id === columnId);
                                    if (!column) return null; // Skip if column doesn't exist

                                    // Only display columns that are in filteredColumns
                                    if (!filteredColumns.find(col => col.id === columnId)) {
                                        return null;
                                    }
                                    return (
                                        <SortableCell key={column.id} index={index} value={
                                            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', minWidth: column.minWidth }} className='table-header-div'>
                                                {column.label}
                                                {column.sortable !== false && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={(event) => handleRequestSort(event, column.id)}
                                                    >
                                                        <img src={SortIcon} alt="Sort" />
                                                    </IconButton>
                                                )}
                                            </div>
                                        } />
                                    );
                                })}
                            </SortableHead>
                            <TableBody>
                                {
                                    loading ? (
                                        [...Array(rowsPerPage)].map((_, index) => (
                                            <TableRow key={index}>
                                                {columns.map((column) => (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <Skeleton height={40} />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    ) : paginatedData.length === 0 ? (
                                        // Display "No Data Found" row if no data is present in the paginated data
                                        <TableRow>
                                            <TableCell colSpan={columns.length}>
                                                <img src={noDataFound} alt="" style={{ height: "250px", width: "280px" }} />
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        paginatedData.map((customer) => (
                                            <TableRow key={customer.id}
                                                // className='table-row-data-container'
                                                className={`table-row-data-container ${customer.Expired === "Yes" ? "expired-row" : ""}`}
                                            >
                                                {columnsOrder.map((columnId) => {
                                                    const column = columns.find((col) => col.id === columnId);
                                                    if (!column || !filteredColumns.find(col => col.id === columnId)) {
                                                        return null; // Skip if column doesn't exist or not selected
                                                    }
                                                    return (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            className={clickedCell.rowId === customer.CompanyID && clickedCell.columnId === column.id ? 'clicked-value' : ''}
                                                            onMouseDown={() => setClickedCell({ rowId: customer.CompanyID, columnId: column.id })}
                                                            onMouseUp={() => setClickedCell({ rowId: null, columnId: null })}
                                                            onMouseLeave={() => setClickedCell({ rowId: null, columnId: null })}
                                                        >
                                                            {column.id === 'Status' ? (
                                                                // <span
                                                                //     className={`status-badge ${customer.Status === 'Active' ? 'complete-status no-dropdown-badge' : 'cancel-status no-dropdown-badge'}`}
                                                                // >
                                                                //     {customer.Status}
                                                                // </span>
                                                                <span
                                                                    className={`status-badge ${customer.Expired === "Yes"
                                                                        ? "inprogress-status no-dropdown-badge" // If expired, use cancel badge
                                                                        : customer.Status === "Active"
                                                                            ? "complete-status no-dropdown-badge"
                                                                            : "cancel-status no-dropdown-badge"
                                                                        }`}
                                                                >
                                                                    {customer.Expired === "Yes" ? "Expired" : customer.Status}
                                                                </span>
                                                            ) : column.id === "EmailID" ? (
                                                                <div className="email-container">
                                                                    <span className="d-flex flex-column">
                                                                        {customer.IsEmailVerified ? (
                                                                            <div className="d-flex align-items-center">
                                                                                <p className="verified-email m-0"><FaCheck className="text-success" /></p>&nbsp;&nbsp;
                                                                                <span>{customer.EmailID}</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div>
                                                                                <div className="d-flex align-items-center">
                                                                                    <p className="unverified-email m-0"><FaTimes className="text-danger" /></p>&nbsp;&nbsp;
                                                                                    <span>{customer.EmailID}</span>
                                                                                </div>
                                                                                {/* "Verify" link */}
                                                                                <button className="verify-email-btn"
                                                                                    onClick={() => { handleResendEmailVerification(customer.EncCompanyCode, customer.EncSignInType) }}
                                                                                >
                                                                                    Send Verification Email
                                                                                </button>
                                                                            </div>

                                                                        )}
                                                                    </span>
                                                                </div>
                                                            ) :
                                                                column.id === 'action' ? (
                                                                    // <img src={action} alt="" onClick={(event) => handleActionClick(event, customer)} />
                                                                    <SbActionDropdownButton
                                                                        openAddModal={() => {
                                                                            handleOpenModal(customer.CompanyCode, customer.CompanyID)
                                                                        }}
                                                                        addBulkModel={() => handleViewDetails(customer.CompanyCode, customer.CompanyID)}
                                                                        moduleData={moduleData}
                                                                    />
                                                                ) : (
                                                                    <span
                                                                        // onClick={() => {
                                                                        //     setClickedCell({ rowId: customer.id, columnId: column.id }); // Track clicked cell
                                                                        //     handleOpenValueFilterModal(); // Open modal
                                                                        // }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation(); // Prevent triggering the row click event
                                                                            if (location.state?.isSwitchToClient) {
                                                                                setShowSwitchModal(true); // Open new modal
                                                                                setCompanyId(customer.CompanyID)
                                                                                setCustomerStatus(customer.StatusID)
                                                                                setCompanyName(customer.CompanyName);
                                                                            } else {
                                                                                const columnValue = customer[column.id];

                                                                                // Alert the column value
                                                                                // alert(`Value of column ${column.id}: ${columnValue}`);
                                                                                setClickedCell({ rowId: customer.id, columnId: column.id }); // Track clicked cell
                                                                                handleOpenValueFilterModal(column.id, columnValue); // Open original modal
                                                                            }
                                                                        }}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        {column.id === 'StartDate' ? (
                                                                            moment(customer.StartDate, 'DD-MM-YYYY', true).isValid()
                                                                                ? moment(customer.StartDate, 'DD-MM-YYYY').format(DateFormat || 'MM/DD/YYYY')
                                                                                : "Invalid Date"
                                                                        ) : column.id === 'EndDate' ? (
                                                                            moment(customer.EndDate, 'DD-MM-YYYY', true).isValid()
                                                                                ? moment(customer.EndDate, 'DD-MM-YYYY').format(DateFormat || 'MM/DD/YYYY')
                                                                                : "Invalid Date"
                                                                        ) : (
                                                                            customer[column.id]
                                                                        )}
                                                                    </span>
                                                                )
                                                            }
                                                        </TableCell>

                                                    )
                                                })}

                                            </TableRow>
                                        )
                                        ))}

                            </TableBody>
                        </Table>
                        <Modal
                            show={showSwitchModal}
                            onHide={handleSwitchClientCancel}
                            className='sw-modal'
                            backdrop="static" // Prevents closing when clicking outside
                            keyboard={false}  // Prevents closing on ESC key
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Switch to Client</Modal.Title>
                            </Modal.Header>
                            {/* <Modal.Body>
                                {customerStatus === 6 ? (
                                    <p>Switching to the client is not possible as the customer is Inactive.</p>
                                ) : customerStatus === 7 ? (
                                    <p>Switching to the client is not possible as the customer is Disabled.</p>
                                ) : (
                                    <div>
                                        <p>Are you sure you want to switch to <strong>{companyName}</strong> client?</p>
                                        <div className='d-flex align-items-center justify-content-center gap-2 p-2'>
                                            <img src={microsoftLogo} alt="linkedin" className='login-cmp-icons' />
                                            <img src={oktaLogo} alt="linkedin" className='login-cmp-icons' />
                                        </div>
                                    </div>
                                )}
                            </Modal.Body> */}
                            <Modal.Body>
                                {customerStatus === 6 ? (
                                    <p>Switching to the client is not possible as the customer is Inactive.</p>
                                ) : customerStatus === 7 ? (
                                    <p>Switching to the client is not possible as the customer is Disabled.</p>
                                ) : showImageDiv ? (
                                    <div>
                                        <p>Authenticate yourself to switch to <strong>{companyName}</strong> client?</p>
                                        <div className='d-flex align-items-center justify-content-center gap-2 p-2'>
                                            <img src={microsoftLogo} alt="microsoft" className='login-cmp-icons' onClick={handleloginWithMicrosoft} />
                                            <img src={oktaLogo} alt="okta" className='login-cmp-icons' onClick={handleOctaAuth} />
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <p>Are you sure you want to switch to <strong>{companyName}</strong> client?</p>
                                    </div>
                                )}
                            </Modal.Body>

                            <Modal.Footer>
                                <SbCancelBtn btnName={!showImageDiv ? "No" : "Cancel"} onClickEffect={handleSwitchClientCancel} />
                                {/* <SBSaveUpdateBtn btnName="Confirm" onClickEffect={handleSwitchClientConfirm} /> */}
                                {/* {customerStatus !== 6 && customerStatus !== 7 && (
                                    <SBSaveUpdateBtn btnName="Confirm" onClickEffect={handleSwitchClientConfirm} />
                                )} */}
                                {!showImageDiv && <SBSaveUpdateBtn btnName="Yes" onClickEffect={handleOpenAthenticator} />}
                            </Modal.Footer>
                        </Modal>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => setAnchorEl(null)}
                            className='header-menu-items'
                        >
                            <MenuItem onClick={() => handleSortOrderChange('asc')} className='header-menu-options'>
                                <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                                Ascending to Descending
                            </MenuItem>
                            <MenuItem onClick={() => handleSortOrderChange('desc')} className='header-menu-options'>
                                <img src={descToAsc} alt="" />&nbsp;&nbsp;
                                Descending to Ascending
                            </MenuItem>
                        </Menu>
                    </TableContainer >
                    {/* Use PaginationComponent */}
                    < PaginationComponent
                        totalItems={totalDataCount}
                        itemsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                    />
                </>
            ) : (
                <div className='d-flex align-items-center justify-content-center p-3'>
                    <img src={noModuleAccess} alt="" />
                </div>
            )
            }
        </>
    );
};

export default CustomerManagementTable;

